import css from 'styled-jsx/css';

const styles = css`.icon-text-button,a.icon-text-button{border:0;color:#0028d8;background-color:transparent;font-size:16px;text-align:left;margin:0;padding:0;position:relative;cursor:pointer}.icon-text-button :global(svg),a.icon-text-button :global(svg){fill:#0028d8;width:24px;height:24px;vertical-align:bottom;margin-right:-4px}`;

export default styles;